// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputBarBlueSmall {
    width: 130px;
    padding: 3px;
    font-size: 11px;
    border-radius: 5px;
    outline: none;
    padding: 8px;
    border: 1px solid var(--InputBarBlueBorderColor);
    background-color: var(--InputBarBlueBackground);
    color: white;
}

.InputBarBlueSmall:focus {
    border: 1px solid var(--InputBarBlueOnFocus);
}

.InputBarBlueSmallIsGray {
    width: 130px;
    padding: 3px;
    font-size: 11px;
    border-radius: 5px;
    outline: none;
    opacity: 0.3;
}

.InputBarBlueSmallIsGray::-webkit-input-placeholder {
    color: gray;
    opacity: 0.8;
}

.InputBarBlueSmall::-webkit-input-placeholder {
    color: gray;
    opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/InputBar/small/InputBarSmall.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gDAAgD;IAChD,+CAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".InputBarBlueSmall {\n    width: 130px;\n    padding: 3px;\n    font-size: 11px;\n    border-radius: 5px;\n    outline: none;\n    padding: 8px;\n    border: 1px solid var(--InputBarBlueBorderColor);\n    background-color: var(--InputBarBlueBackground);\n    color: white;\n}\n\n.InputBarBlueSmall:focus {\n    border: 1px solid var(--InputBarBlueOnFocus);\n}\n\n.InputBarBlueSmallIsGray {\n    width: 130px;\n    padding: 3px;\n    font-size: 11px;\n    border-radius: 5px;\n    outline: none;\n    opacity: 0.3;\n}\n\n.InputBarBlueSmallIsGray::-webkit-input-placeholder {\n    color: gray;\n    opacity: 0.8;\n}\n\n.InputBarBlueSmall::-webkit-input-placeholder {\n    color: gray;\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
